import { call, put, select } from 'redux-saga/effects';
import { bulkScreensharesClosed, localScreenshareStopped } from 'features/screenshare/actions';
import { selectLocalUserId } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import {
  screensharesDeleted,
  selectScreenshareStreams,
} from 'features/layout/features/order/orderSlice';
import { UserScreenshareSource } from 'features/layout/features/order/types';
import { getScreenshareFeedIds } from 'features/screenshare/utils/getScreenshareFeedIds';
import { filterScreenshareStreamsByIds } from 'features/screenshare/utils/filterScreenshareStreamsByIds';
import { cleanupScreenshareStreamsSaga } from 'features/screenshare/sagas/cleanupScreenshareStreamsSaga';
import { clearLockedContentSaga } from 'features/layout/features/content/sagas/clearLockedContentSaga';
import { FeedId, MediaStreamInfo } from 'features/streaming/types';
import { gridPanelTabClosed } from 'features/layout/features/content/contentSlice';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { selectShowAllScreens, showAllScreensChanged } from 'features/screenshare/screenshareSlice';
import { RTCClient } from 'utils/webrtc';

export function* bulkScreensharesClosedSaga(ids: string[]) {
  yield put(bulkScreensharesClosed(ids));

  const localUserId: UserId = yield select(selectLocalUserId);
  const allStreams: UserScreenshareSource[] = yield select(selectScreenshareStreams);

  const streams: UserScreenshareSource[] = yield call(
    filterScreenshareStreamsByIds,
    allStreams,
    ids
  );

  if (streams.length === 0) {
    return;
  }

  for (const { userId, feedId } of streams) {
    if (userId === localUserId) {
      yield put(localScreenshareStopped());
    } else if (feedId) {
      const feedStreams: MediaStreamInfo[] = yield call(
        RTCClient.receivingFeed.media.getMediaList,
        feedId
      );

      yield call(cleanupScreenshareStreamsSaga, {
        userId,
        feedId,
        streams: feedStreams,
      });
    }
  }

  const feedIds: FeedId[] = yield call(getScreenshareFeedIds, streams);

  yield put(screensharesDeleted({ ids: feedIds }));

  yield call(clearLockedContentSaga, { type: 'screenshare', ids: feedIds });

  const remaining: UserScreenshareSource[] = yield select(selectScreenshareStreams);

  if (remaining.length === 0) {
    yield put(gridPanelTabClosed('screenshare'));

    if (contentBoard.id && contentBoard.type === 'screenshare') {
      yield call(contentBoard.clean);
      contentBoard.type = 'file';
      contentBoard.id = null;
    }

    return;
  }

  const showAllScreens: boolean = yield select(selectShowAllScreens);

  if (showAllScreens && remaining.length === 1) {
    yield put(showAllScreensChanged(false));
  }
}
